import {
  Body,
  Controller,
  Delete,
  Get,
  Param,
  Patch,
  Post,
  Query,
  UseGuards,
} from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import { RequireModule } from '../../auth/decorators/require-module.decorator';
import { RequirePermission } from '../../auth/decorators/require-permission.decorator';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { GetUser } from '../../auth/get-user.decorator';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import {
  CreateToleranciaEspecialDto,
  QueryToleranciasEspecialesDto,
  UpdateToleranciaEspecialDto,
} from '../dto/presentismo-fase3.dto';
import { ToleranciasPresentismoService } from '../services/tolerancias-presentismo.service';

@ApiTags('RRHH - Presentismo - Tolerancias especiales')
@Controller({ path: 'rrhh/presentismo', version: '1' })
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('RRHH')
@ApiBearerAuth()
export class ToleranciasPresentismoController {
  constructor(private readonly service: ToleranciasPresentismoService) {}

  @Get('tolerancias-especiales')
  @RequirePermission('RRHH', 'RH_MAR_MARCACION_VER')
  @ApiOperation({ summary: 'Listar tolerancias especiales' })
  listar(@GetUser() user: LoginUserInfo, @Query() query: QueryToleranciasEspecialesDto) {
    return this.service.listar(user.empresa_id, query);
  }

  @Get('tolerancias-especiales/:id')
  @RequirePermission('RRHH', 'RH_MAR_MARCACION_VER')
  @ApiOperation({ summary: 'Obtener tolerancia especial por ID' })
  obtener(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.obtener(id, user.empresa_id);
  }

  @Post('tolerancias-especiales')
  @RequirePermission('RRHH', 'RH_MAR_MARCACION_CREAR')
  @ApiOperation({ summary: 'Crear tolerancia especial por fecha' })
  crear(@GetUser() user: LoginUserInfo, @Body() dto: CreateToleranciaEspecialDto) {
    return this.service.crear(user.empresa_id, dto, user.id);
  }

  @Patch('tolerancias-especiales/:id')
  @RequirePermission('RRHH', 'RH_MAR_MARCACION_EDITAR')
  @ApiOperation({ summary: 'Actualizar tolerancia especial' })
  actualizar(
    @Param('id') id: string,
    @GetUser() user: LoginUserInfo,
    @Body() dto: UpdateToleranciaEspecialDto,
  ) {
    return this.service.actualizar(id, user.empresa_id, dto);
  }

  @Delete('tolerancias-especiales/:id')
  @RequirePermission('RRHH', 'RH_MAR_MARCACION_ELIMINAR')
  @ApiOperation({ summary: 'Eliminar tolerancia especial' })
  eliminar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.eliminar(id, user.empresa_id);
  }
}
